var _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    id: "notes",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -1004.362)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 1028.362,
    r: 24,
    fill: "#239fdb",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0b5ecd",
    style: {
      lineHeight: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      blockProgression: "tb",
      isolation: "auto",
      mixBlendMode: "normal"
    },
    d: "M25.016 47.963a24 24 0 0 0 .681-.024 24 24 0 0 0 2.383-.289 24 24 0 0 0 2.34-.525 24 24 0 0 0 2.277-.756 24 24 0 0 0 2.19-.98 24 24 0 0 0 2.08-1.194 24 24 0 0 0 1.951-1.394 24 24 0 0 0 1.803-1.584 24 24 0 0 0 1.634-1.756 24 24 0 0 0 1.454-1.91 24 24 0 0 0 1.254-2.045 24 24 0 0 0 1.042-2.16 24 24 0 0 0 .823-2.254A24 24 0 0 0 47.463 29L34.38 15.92l-.01-.012c-.006-.01-.013-.015-.02-.023l-5-5a.493.493 0 0 0-.351-.147H28.654l-.9-.431a.502.502 0 0 0-.244-.05v.005h-.01l-6.33.474H14a.498.498 0 0 0-.5.5v.602l-1.07.152a.5.5 0 0 0-.424.565v.004L13.5 22.967V36.24a.502.502 0 0 0 .146.354l11.37 11.369z",
    color: "#000",
    fontFamily: "sans-serif",
    fontWeight: 400,
    transform: "translate(0 1004.362)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      lineHeight: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      blockProgression: "tb",
      isolation: "auto",
      mixBlendMode: "normal"
    },
    d: "M19.01 1.52v.003H19l-6.33.475h-.037L12.62 2H5.5a.5.5 0 0 0-.5.5v.602l-1.07.152a.5.5 0 0 0-.424.564L5 14.23V27.5a.5.5 0 0 0 .5.5h1.477l.08.56a.5.5 0 0 0 .564.424l4.832-.693.422.48a.5.5 0 0 0 .723.032l.826-.795.055-.008H25.5a.5.5 0 0 0 .5-.5v-1.154l1.418-.203a.5.5 0 0 0 .424-.565l-1.297-9.043c.096-.07.193-.14.283-.23l.277-.278c.336-.335.61-.714.79-1.109l1.255-2.764c.116-.255.17-.625-.103-.898a.657.657 0 0 0-.455-.195.952.952 0 0 0-.444.093L26 12.13V7.535a.5.5 0 0 0 0-.035v-.014c0-.011 0-.023-.002-.035l-.002-.015a.502.502 0 0 0-.018-.082l-.003-.014a.514.514 0 0 0-.014-.033l-.002-.002-.004-.012a.473.473 0 0 0-.016-.031l-.007-.014-.002-.004a.5.5 0 0 0-.047-.064l-.01-.012a.497.497 0 0 0-.02-.022l-5-5A.499.499 0 0 0 20.5 2H20.154l-.9-.432a.5.5 0 0 0-.244-.048zM6 3h14v4.5a.5.5 0 0 0 .5.5H25v4.62a3.32 3.32 0 0 0-.627.484l-.826.824c-.02.02-.03.048-.049.07H7V15h15.516l-2.149 2H7v1h12.291l-2.148 2H7v1h9.068l-2.146 1.998H7V24h5.846l-1.932 1.797a.5.5 0 0 0-.035.695l.445.508H6V3Zm15 .707L24.293 7H21V3.707ZM5 4.105V7.2l-.436-3.031L5 4.105ZM7 8v1h9V8H7Zm0 3v1h16.5v-1H7Zm20.969 1.334-.987 2.17c-.118.26-.324.557-.584.816l-.277.278a1.131 1.131 0 0 1-.365.25l-1.358-1.358.682-.68a2.23 2.23 0 0 1 .613-.443l2.276-1.033zm-4.256 2.92 1.23 1.23-9.998 9.63-1.361-1.434 10.129-9.426zM25 17.818V27h-9.531l3.113-3H24v-1.002h-4.377L21.697 21H23.5v-1h-.766L25 17.818Zm1 1.955.781 5.452-.781.113v-5.565Zm-13.148 5.588 1.375 1.446-.946.91-1.33-1.518.9-.838z",
    color: "#000",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible",
    transform: "translate(8.5 1013.108)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.f082e9ea93277bb5bef772ee89e5f51a.svg";
export { ForwardRef as ReactComponent };